import React from "react";
import styles from "./MembershipCard.module.scss";
import { useNavigate } from "react-router-dom";
import { Desktop, MobileTablet } from "../../../assets/mediaQuery/mediaQuery";
import CommonButton from "../../common/buttons/CommonButton/CommonButton";
import MembershipCardTitle from "./MembershipCardTitle";
import MembershipCardBox from "./MembershipCardBox";
import MembershipSingleSlide from "./MembershipSingleSlide";

// 기타 공간 사용 안내
const otherDataArray = [
  {
    title: "회의실 사용",
    content: [
      "회의실은 예약제로 운영됩니다.",
      "프라이빗 오피스 회원은 주 5시간 무료 사용이 가능합니다.",
      "무료 제공 시간을 초과할 경우, 모든 오피스 회원은 정상가의 50% 할인 금액에 이용이 가능합니다.",
      "외부 이용객(비회원)도 회의실 이용이 가능하며, 정상 요금이 적용됩니다.",
    ],
  },
  {
    title: "주차",
    content: [
      "월 정기 주차비용은 이용요금과 별도로 납부하셔야 합니다.",
      "월주차 1대당 88,000원",
      "라운지 이용객은 월주차 불가한 점 양해바랍니다.",
      "건물 내 등록차량 만차 시 월주차 등록이 불가하며, 일주차로 이용해 주셔야 합니다.",
    ],
  },
  {
    title: "프린트 사용",
    subTitle: "풀 디지털 컬러 복합기 월 150포인트 무료 제공",
    content: [
      "잔여 포인트는 다음 달 이월",
      "흑백 1P, 컬러 2P 차감 (A4 기준)",
      "무료 제공 초과 시 유료 → 흑백 장당 ￦50 (부가세 포함), 컬러 장당 ￦100 (부가세 포함) 부과",
    ],
    subTitle02: "무료 프린트 서비스",
    content02: [
      "프라이빗 오피스 회원 전용으로 제공되며, 라운지 이용객은 이용이 불가합니다.",
    ],
  },
  {
    title: "프라이빗 오피스 회원 대상 기타안내",
    subTitle: "보증금 관련 안내",
    content: [
      "보증금은 퇴실 시 반환되는 금액이며, 별도 부가세를 징수하지 않습니다.",
      "이용료 및 보증금은 입주 전 선납이 필수입니다.",
      "보증금은 퇴실일로부터 30일 이내에 전액 환불됩니다.",
    ],
    subTitle02: "운영 관련 안내",
    content02: [
      "기본 제공: 24시간 출입 가능 / 회의실 및 라운지 / 커피, 차 등 음료 제공 / 인터넷, 전기, 수도 제공 (월 이용료에 관리비 포함)",
      "호실별 디지털 도어록 무료 제공",
      "유무선 인터넷 무료 제공 (공인ip 사용 시 별도 과금. 단, 호실 내 네트워크 구성은 입주 고객이 직접 하셔야 합니다.)",
    ],
  },
];

const MembershipCard = ({ cardTitle, cardSubTitle, item }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <MembershipCardTitle title={cardTitle} subTitle={cardSubTitle} />
      {item.title === "비상주 사무실" && (
        <>
          <div className={`${styles.cardOuterBox}`}>
            <div className={`${styles.cardBox} ${styles.cardBetweenBox}`}>
              <MembershipCardBox title={"6개월"} hasMarginBottom>
                {[
                  {
                    price: "300,000원",
                  },
                ].map((item) => {
                  return (
                    <React.Fragment key={item.price}>
                      <div className={`${styles.cardBox__normal}`}>
                        <span
                          className={`${styles.cardBox__normal_priceTxt02}`}
                        >
                          {item.price}
                        </span>
                      </div>
                    </React.Fragment>
                  );
                })}
              </MembershipCardBox>
              <MembershipCardBox title={"1년"} hasMarginBottom>
                {[
                  {
                    price: "600,000원",
                  },
                ].map((item) => {
                  return (
                    <React.Fragment key={item.price}>
                      <div className={`${styles.cardBox__normal}`}>
                        <span
                          className={`${styles.cardBox__normal_priceTxt02}`}
                        >
                          {item.price}
                        </span>
                      </div>
                    </React.Fragment>
                  );
                })}
              </MembershipCardBox>
            </div>
            <span className={styles.cardBox__txt_btm}>
              ※ 부가세 별도 가격입니다.
            </span>
          </div>
        </>
      )}
      {item.title === "라운지 패스" && (
        <>
          <div className={`${styles.cardOuterBox}`}>
            <div className={`${styles.cardBox} ${styles.cardColBox}`}>
              <MembershipCardBox title={"라운지 당일권"} hasMarginBottom>
                {[
                  {
                    time: 2,
                    price: "4,000",
                  },
           
                  {
                    time: 5,
                    price: "9,000",
                  },
               
                  {
                    time: 10,
                    price: "16,000",
                  },
                  {
                    time: 24,
                    price: "25,000",
                  },
                ].map((item) => {
                  return (
                    <React.Fragment key={item.time}>
                      <div
                        className={`${styles.cardBox__normal} ${styles.cardBox__normal02}`}
                      >
                        <span className={styles.cardBox__normal_timeTxt}>
                          {item.time}시간
                        </span>
                        <span className={`${styles.cardBox__txt_center}`}>
                          -
                        </span>
                        <span
                          className={`${styles.cardBox__normal_priceTxt01} ${styles.cardBox__normal_priceTxt}`}
                        >
                          {item.price}원
                        </span>
                      </div>
                    </React.Fragment>
                  );
                })}
              </MembershipCardBox>
              <MembershipCardBox title={"기간 이용권"} hasMarginBottom>
                {[
                  {
                    time: "7일",
                    price: "100,000원",
                  },
                  {
                    time: "30일",
                    price: "190,000원",
                  },
                  {
                    time: "90일",
                    price: "500,000원",
                  },
                  {
                    time: "180일",
                    price: "900,000원",
                  },
                  {
                    time: "365일",
                    price: "1,600,000원",
                  },
                ].map((item) => {
                  return (
                    <React.Fragment key={item.time}>
                      <div
                        className={`${styles.cardBox__normal} ${styles.cardBox__normal03}`}
                      >
                        <span className={styles.cardBox__normal_timeTxt}>
                          {item.time}
                        </span>
                        <span className={`${styles.cardBox__txt_center}`}>
                          -
                        </span>
                        <span
                          className={`${styles.cardBox__normal_priceTxt02} ${styles.cardBox__normal_priceTxt}`}
                        >
                          {item.price}
                        </span>
                      </div>
                    </React.Fragment>
                  );
                })}
              </MembershipCardBox>
              <MembershipCardBox title={"시간 패키지 (소진 기간)"} hasMarginBottom>
                {[
                  {
                    time: "50시간",
                    price: "60,000원 (30일 이내)",
                  },
                  {
                    time: "100시간",
                    price: "90,000원 (120일 이내)",
                  },
                  {
                    time: "200시간",
                    price: "170,000원 (300일 이내)",
                  },
                  {
                    time: "300시간",
                    price: "210,000원 (365일 이내)",
                  },

                ].map((item) => {
                  return (
                    <React.Fragment key={item.time}>
                      <div
                        className={`${styles.cardBox__normal} ${styles.cardBox__normal02}`}
                      >
                        <span className={styles.cardBox__normal_timeTxt}>
                          {item.time}
                        </span>
                        <span className={`${styles.cardBox__txt_center}`}>
                          -
                        </span>
                        <span
                          className={`${styles.cardBox__normal_priceTxt02} ${styles.cardBox__normal_priceTxt}`}
                        >
                          {item.price}
                        </span>
                      </div>
                    </React.Fragment>
                  );
                })}
              </MembershipCardBox>
            </div>
            <span className={styles.cardBox__txt_btm}>
              ※ 라운지 패스는 기간에 상관없이 사용한 시간만큼 차감되는 시스템입니다.
            </span>
          </div>
        </>
      )}
      {item.title === "독립형 사무실" && (
        <>
          <MobileTablet>
            <div
              key={item.id}
              className={`${styles.cardOuterBox} ${styles.cardOuterBox02}`}
            >
              <div className={`${styles.cardBox} ${styles.cardBox__slideBox}`}>
                <MembershipSingleSlide />
              </div>
              <div className={styles.cardBox__btnBox}>
                <CommonButton
                  color="black"
                  onClick={() => {
                    navigate("/contact");
                  }}
                >
                  방문 신청 →
                </CommonButton>
              </div>
            </div>
          </MobileTablet>
          <Desktop>
            <div className={`${styles.cardOuterBox}`}>
              <div className={`${styles.cardBox} ${styles.cardRowBox}`}>
                <div className={styles.cardBox__imgBox_wrap}>
                  <div className={styles.cardBox__imgBox}>
                    <picture className={styles.cardBox__pic}>
                      <source
                        srcSet={"/assets/images/office_single01.webp"}
                        type="image/webp"
                      />
                      <img
                        className={styles.cardBox__img}
                        src="/assets/images/office_single01.jpg"
                        alt="intro_img"
                        width={"100%"}
                        height={"100%"}
                      />
                    </picture>
                  </div>
                  <div
                    className={`${styles.cardBox__imgBox} ${styles.cardBox__imgBox02}`}
                  >
                    <picture className={styles.cardBox__pic}>
                      <source
                        srcSet={"/assets/images/office_single02.webp"}
                        type="image/webp"
                      />
                      <img
                        className={styles.cardBox__img}
                        src="/assets/images/office_single02.jpg"
                        alt="intro_img"
                        width={"100%"}
                        height={"100%"}
                      />
                    </picture>
                  </div>
                </div>
                <div className={styles.cardBox__btnBox}>
                  <CommonButton
                    color="black"
                    onClick={() => {
                      navigate("/contact");
                    }}
                  >
                    방문 신청 →
                  </CommonButton>
                </div>
              </div>
            </div>
          </Desktop>
        </>
      )}
      {item.title === "기타 공간 사용 안내" && (
        <div className={`${styles.cardBox} ${styles.cardLastBox}`}>
          {otherDataArray.map((other) => {
            return (
              <div key={other.title} className={styles.cardBox__otherBox}>
                <span className={styles.cardBox__otherBox_titleTxt}>
                  {other.title}
                </span>
                {other.title === "회의실 사용" && (
                  <div>
                    <div className={`${styles.cardBox} ${styles.cardBetweenBox}`}>
                      <MembershipCardBox
                        isOtherMode
                        innerTitle={"< 소회의실 >"}
                        innerSubTitle={"최대 4명"}
                      >
                        {[
                          {
                            time: 1,
                            price: "25,000",
                          },
                          {
                            time: 2,
                            price: "50,000",
                          },
                          {
                            time: 3,
                            price: "65,000",
                          },
                          {
                            time: 4,
                            price: "80,000",
                          },
                          {
                            time: 5,
                            price: "90,000",
                          },
                          {
                            time: 6,
                            price: "100,000",
                          },
                          {
                            time: 7,
                            price: "110,000",
                          },
                          {
                            time: 8,
                            price: "120,000",
                          },
                          {
                            time: 9,
                            price: "130,000",
                          },
                        ].map((item) => {
                          return (
                            <React.Fragment key={item.time}>
                              <div className={styles.cardBox__other}>
                                <span className={styles.cardBox__other_timeTxt}>
                                  {item.time}시간
                                </span>
                                <span
                                  className={`${styles.cardBox__other_center}`}
                                >
                                  -
                                </span>
                                <span
                                  className={styles.cardBox__other_priceTxt}
                                >
                                  {item.price}원
                                </span>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </MembershipCardBox>
                      <MembershipCardBox
                        isOtherMode
                        innerTitle={"< 중회의실 >"}
                        innerSubTitle={"최대 7명"}
                      >
                        {[
                          {
                            time: 1,
                            price: "30,000",
                          },
                          {
                            time: 2,
                            price: "60,000",
                          },
                          {
                            time: 3,
                            price: "80,000",
                          },
                          {
                            time: 4,
                            price: "100,000",
                          },
                          {
                            time: 5,
                            price: "120,000",
                          },
                          {
                            time: 6,
                            price: "140,000",
                          },
                          {
                            time: 7,
                            price: "150,000",
                          },
                          {
                            time: 8,
                            price: "160,000",
                          },
                          {
                            time: 9,
                            price: "170,000",
                          },
                        ].map((item) => {
                          return (
                            <React.Fragment key={item.time}>
                              <div className={styles.cardBox__other}>
                                <span className={styles.cardBox__other_timeTxt}>
                                  {item.time}시간
                                </span>
                                <span
                                  className={`${styles.cardBox__other_center}`}
                                >
                                  -
                                </span>
                                <span
                                  className={styles.cardBox__other_priceTxt}
                                >
                                  {item.price}원
                                </span>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </MembershipCardBox>
                      <MembershipCardBox
                        isOtherMode
                        innerTitle={"< 대회의실 >"}
                        innerSubTitle={"최대 10명"}
                      >
                        {[
                          {
                            time: 1,
                            price: "40,000",
                          },
                          {
                            time: 2,
                            price: "80,000",
                          },
                          {
                            time: 3,
                            price: "100,000",
                          },
                          {
                            time: 4,
                            price: "130,000",
                          },
                          {
                            time: 5,
                            price: "160,000",
                          },
                          {
                            time: 6,
                            price: "180,000",
                          },
                          {
                            time: 7,
                            price: "190,000",
                          },
                          {
                            time: 8,
                            price: "200,000",
                          },
                          {
                            time: 9,
                            price: "210,000",
                          },
                        ].map((item) => {
                          return (
                            <React.Fragment key={item.time}>
                              <div className={styles.cardBox__other}>
                                <span className={styles.cardBox__other_timeTxt}>
                                  {item.time}시간
                                </span>
                                <span
                                  className={`${styles.cardBox__other_center}`}
                                >
                                  -
                                </span>
                                <span
                                  className={styles.cardBox__other_priceTxt}
                                >
                                  {item.price}원
                                </span>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </MembershipCardBox>
                    </div>
                  </div>
                )}
                {other.subTitle && (
                  <span className={styles.cardBox__otherBox_subTxt}>
                    {other.subTitle}
                  </span>
                )}
                {other.content?.map((cont, index) => {
                  return (
                    <ul key={index}>
                      <li className={styles.cardBox__otherBox_contTxt}>
                        <div>&middot;&nbsp;&nbsp;</div>
                        {cont}
                      </li>
                    </ul>
                  );
                })}
                {other.subTitle02 && (
                  <span
                    className={`${styles.cardBox__otherBox_subTxt} ${styles.cardBox__otherBox_subTxt02}`}
                  >
                    {other.subTitle02}
                  </span>
                )}
                {other.content02?.map((cont, i) => {
                  return (
                    <ul key={i}>
                      <li className={styles.cardBox__otherBox_contTxt}>
                        <div>&middot;&nbsp;&nbsp;</div>
                        {cont}
                      </li>
                    </ul>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MembershipCard;
